import { Box, Typography, Container, useTheme } from "@mui/material";
import { tokens } from "../../theme";

const Footer = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        backgroundColor: colors.primary[400],
        borderTop: `1px solid ${colors.blueAccent[400]}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexWrap="wrap"
        >
          <Typography variant="body3" sx={{ color: colors.grey[100] }}>
            © {new Date().getFullYear()} <b>CONATEL</b> - Sistema de Denuncias -
            Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
